export const mapGoals = (items, mapping = {}) =>
  Object.keys(items)
    .map(key => ({
      score: items[key],
      id: key,
      title: mapping[key]?.title ?? key,
      ...(mapping[key]?.to && { to: mapping[key]?.to })
    }))
    .sort((a, b) => (a.id > b.id ? 1 : -1));
